import { sendPost, sendGet } from "./generic"

export const getEntityTypes = ()=> {
    return sendGet("Registrations/EntityTypes")
}

export const register = (payload)=> {
    return sendPost("Registrations", payload)
}